
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health/weight/[[...path]]",
      function () {
        return require("private-next-pages/health/weight/[[...path]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health/weight/[[...path]]"])
      });
    }
  